/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import { Input } from 'antd'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      phoneError: {},
    }
  }

  checkPhone = (phone) => {
    let phoneNumber = phone.replace(/\D/g, '')
    if (phoneNumber.length == 11) {
      this.setState({ phoneError: { state: false, status: '' } })
      sessionStorage.setItem('official_phone', phoneNumber)
    } else if (phoneNumber.length > 11) {
      this.setState({ phoneError: { state: true, status: '手机号码超过11位' } })
    } else {
      this.setState({
        phoneError: { state: true, status: `还有${11 - phoneNumber.length}位` },
      })
    }
    // return false;
  }
  render() {
    const { clubInfo } = this.props
    return (
      <div style={{ textAlign: 'center' }}>
        <div style={{ marginTop: '1rem' }}>
          <span className="info-span">密码:</span>
          <Input
            type="password"
            size="large"
            style={{ width: '50%', marginLeft: '2.4rem' }}
            placeholder="请输入要修改的密码,可以不填写"
            onChange={(e) => sessionStorage.setItem('password', e.target.value)}
          />
        </div>
        <div style={{ marginTop: '1rem' }}>
          <span className="info-span">负责人:</span>
          <Input
            size="large"
            defaultValue={clubInfo.official_person}
            style={{ width: '50%', marginLeft: '1.8rem' }}
            placeholder="请输入要负责人姓名"
            onChange={(e) => sessionStorage.setItem('name', e.target.value)}
          />
        </div>
        <div style={{ marginTop: '1rem' }}>
          <span className="info-span">联系电话:</span>
          <Input
            size="large"
            defaultValue={clubInfo.contact_number}
            style={{ width: '50%', marginLeft: '1.2rem' }}
            placeholder="请输入联系电话"
            onChange={(e) => sessionStorage.setItem('phone', e.target.value)}
          />
        </div>
        <div style={{ marginTop: '1rem' }}>
          <span className="info-span">手机号码:</span>
          <Input
            size="large"
            defaultValue={clubInfo.official_person_phone}
            style={{ width: '50%', marginLeft: '1.2rem' }}
            type="tel"
            placeholder="请输入负责人手机号码"
            pattern="1\d{10}"
            onChange={(e) => this.checkPhone(e.target.value)}
          />
          {this.state.phoneError.state ? (
            <i className="weui_icon_info">{this.state.phoneError.status}</i>
          ) : (
            ''
          )}
        </div>
        <div style={{ marginTop: '1rem' }}>
          <span className="info-span">地址:</span>
          <Input
            size="large"
            defaultValue={clubInfo.club_address}
            style={{ width: '50%', marginLeft: '2.4rem' }}
            placeholder="请输入俱乐部详细地址"
            onChange={(e) =>
              sessionStorage.setItem('club_address', e.target.value)
            }
          />
        </div>
        <div style={{ marginTop: '1rem' }}>
          <span className="info-span">俱乐部名称:</span>
          <Input
            size="large"
            defaultValue={clubInfo.club_name}
            style={{ width: '50%', marginLeft: '.2rem' }}
            placeholder="请输入俱乐部名称"
            onChange={(e) =>
              sessionStorage.setItem('club_name', e.target.value)
            }
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubList/component/alter.js